import { em } from 'polished'
import styled, { css } from 'styled-components'

import FrameMacStraight from 'components/FrameMacStraight'

export const Cover = styled.div`
  position: absolute;
  right: 0;
  height: 100%;
  background: ${p => p.theme.colors.mineShaft};
  display: ${p => (p.isTablet ? 'none' : 'block')};
  ${p =>
    p.isTablet
      ? css`
          width: 59%;
        `
      : css`
          width: 90%;
        `}

  ${p => p.theme.mq.upMd} {
    right: auto;
    display: ${p => (p.isTablet ? 'block' : 'none')};
  }

  ${p => p.theme.mq.upLg} {
    width: 60%;
  }
`

export const Content = styled.div`
  min-height: 0;
  display: flex;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};
`

export const FrameMacStraightStyled = styled(FrameMacStraight)`
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    margin: ${em(54)} 0 0;
    left: -${em(265)};
  }

  ${p => p.theme.mq.upLg} {
    margin-top: ${em(70)};
    left: auto;
  }
`

export const IconWrapper = styled.div`
  position: absolute;
  z-index: 4;
  -webkit-backface-visibility: hidden;

  &.charts {
    width: ${em(120)};
    height: ${em(120)};
    top: 0;
    left: ${em(160)};
    transform: translate(0, -70%);

    ${p => p.theme.mq.upMd} {
      width: ${em(150)};
      height: ${em(150)};
      left: auto;
      right: 55%;
      transform: translate(259%, -63%);
    }

    ${p => p.theme.mq.upLg} {
      right: 0;
      transform: translate(-200%, -70%);
    }
  }

  &.profile {
    width: ${em(100)};
    height: ${em(100)};
    bottom: 0;
    left: 0;
    transform: translate(0, 40%);

    ${p => p.theme.mq.upMd} {
      transform: translate(558%, 16%);
    }

    ${p => p.theme.mq.upLg} {
      width: ${em(150)};
      height: ${em(150)};
      left: auto;
      right: 0;
      transform: translate(-25%, 20%);
    }
  }
`

export const HeaderWrapper = styled.div`
  ${p => p.theme.mq.upMd} {
    padding-left: ${p => p.theme.indents.baseIndentMd};
  }

  ${p => p.theme.mq.upLg} {
    padding-left: 0;
  }
`
